import clsx from "clsx";
import React, { useEffect, useState } from "react";

// import ChevronIcon from "/public/images/all-games-arrow.svg";
import CumParticipTab from "./components/howItWorks/CumParticipTab";
import { TABS } from "./utils/tabsConfig";
import { TabKey, TabType } from "./utils/types";
//import { getCookie } from "../../../../../../../helpers/cookies";
import ChevronsRightIcon from "@/app/shared-components/icons/ChevronsRightIcon";
import CloseModalIcon from "@/app/shared-components/icons/CloseModalIcon";
import { useRaffleContext } from "../../../../../../(custom-header)/spring-daily-raffle/context";
import { useSmarticoRaffleDrawById } from "../../../store";
import { SmarticoRaffleDrawIds } from "../../../interfaces/SmarticoRaffleDrawIds";
import { useTimer } from "../../../../../../hooks/useTimer";
import { cn } from "../../../../../../../lib/utils";

interface AllPrizesModalProps {
  defaultTab?: TabType;
}

export const AllPrizesModal = ({ defaultTab = TabKey.CUM_PARTICIP }: AllPrizesModalProps) => {
  const { onCloseModal } = useRaffleContext();
  const [activeTab, setActiveTab] = useState<TabType>(defaultTab);
  //const isAuth = getCookie("BotB.Authenticated") === "true";
  const activeTabProps = TABS.find(tab => tab.id === activeTab);
  const ActiveTabComponent = activeTabProps?.component || CumParticipTab;
  const hourlyDraw = useSmarticoRaffleDrawById(SmarticoRaffleDrawIds.HOURLY_DRAW);
  const grandDraw = useSmarticoRaffleDrawById(SmarticoRaffleDrawIds.GRAND_DRAW);
  const draw = hourlyDraw.execution_ts >= Date.now() ? hourlyDraw : grandDraw;
  const timer = useTimer(String(draw.id), draw.execution_ts, undefined, "millisecond");
  const milisecondsT = Math.floor(timer.milliseconds / 10)
    .toString()
    .padStart(2, "0");
  const daysCount = timer.days?.replace(/^0+/, "") || "0";
  const daysLabel = `${daysCount} ${Number(daysCount) === 1 ? "Day" : "Days"}`;

  useEffect(() => {
    document.querySelector("body").classList.add("!overflow-hidden");

    return () => {
      document.querySelector("body").classList.remove("!overflow-hidden");
    };
  }, []);

  return (
    <>
      <div data-name="Overlay" className="fixed inset-0 z-[1005] bg-black/80"></div>

      <div
        data-name="PopupContainer"
        className={"fixed inset-0 z-[1006] w-full min-h-full overflow-x-hidden overflow-y-auto font-jost"}>
        <div className={"w-full min-h-full flex-center flex-col m-auto"}>
          <div
            className={cn(
              "bg-white relative w-full max-lg:max-h-dvh pb-8 lg:pb-5 lg:max-w-[602px] lg:min-h-[614px] flex flex-col max-lg:grow lg:rounded-2xl",
              {
                "pb-0 lg:pb-0": activeTabProps?.options?.hideNextDrawContainer,
              }
            )}>
            {/*close btn*/}
            <div className={"flex items-center py-2 px-3"}>
              <button onClick={onCloseModal} className={"ml-auto"}>
                <CloseModalIcon className={"size-6 text-gray-5"} />
              </button>
            </div>

            {/* Tab Navigation */}
            <div className="flex items-center justify-center">
              {TABS.map(tab => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={clsx(
                    "px-3 h-14 lg:h-12 w-full text-sm lg:text-base font-medium leading-5 lg:leading-5.5 border-b-2 border-white-opacity-1 transition-colors bg-transparent text-gray-1",
                    activeTab === tab.id && "!text-primary !border-primary"
                  )}>
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div className={"px-3 pt-6 overflow-auto bg-gray-4 lg:px-10 lg:max-h-[484px] custom-scrollbar grow"}>
              <div className={`min-h-fit ${!activeTabProps?.options?.hideNextDrawContainer ? "pb-8" : "pb-0"}`}>
                <ActiveTabComponent />
              </div>
            </div>

            {/*bottom sticky counter and button*/}
            {/*TODO - hde this widget on tab 2*/}
            {!activeTabProps?.options?.hideNextDrawContainer ? (
              <div className="w-full absolute bottom-0 left-0 bg-gray-4 pt-2 pb-6 px-3 lg:px-10 flex items-center justify-between shadow-[0px_-1.5px_8px_0px_rgba(0,0,0,0.20)] lg:rounded-b-2xl">
                <div>
                  <div className={"mb-1 uppercase text-gray-5 text-[10px] leading-3 font-medium"}>Next draw in:</div>
                  <div className={"text-sm font-medium text-dark-1 leading-5 lg:text-base lg:leading-5.5"}>
                    {timer.isPastADay ? (
                      <span className={"min-w-3.5 lg:min-w-4.5 inline-flex justify-end text-right"}>{daysLabel}</span>
                    ) : (
                      <>
                        <span className={"min-w-3.5 lg:min-w-4.5 inline-flex justify-end text-right"}>
                          {timer.hours}
                        </span>
                        <span>h : </span>
                        <span className={"min-w-3.5 lg:min-w-4.5 inline-flex justify-end text-right"}>
                          {timer.minutes}
                        </span>
                        <span>m : </span>
                        <span className={"min-w-3.5 lg:min-w-4.5 inline-flex"}>{timer.seconds}</span>
                        <span className={"min-w-3 lg:min-w-3.5 inline-flex text-[9px] lg:text-[10px] leading-none"}>
                          {milisecondsT}
                        </span>
                      </>
                    )}
                  </div>
                </div>
                <div>
                  <button
                    onClick={() => {
                      setActiveTab(TabKey.PREMII_ZILNIC);
                    }}
                    className={"theme-btn theme-btn-primary theme-btn-md uppercase"}>
                    Get draw tickets
                    <ChevronsRightIcon variant={2} className={"size-4 lg:size-6 shrink-0"} />
                  </button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};
